import * as yup from 'yup';
import moment from 'moment';
import {baseUrl} from '../agent';
import keycloak from '../keycloak';

export const VALUE_IS_REQUIRED = 'validation.msg.value.is.required';
export const LIST_CANNOT_BE_EMPTY = 'validation.msg.list.cannot.be.empty';
export const TRADENAME_MUST_BE_UNIQUE = 'validation.msg.tradename.must.be.unique';
export const VALUE_MUST_BE_POSITIVE_INTEGER = 'validation.msg.value.must.be.positive.integer';
export const VALUE_EXCEEDS_MAX = 'validation.msg.value.must.be.less.than.8.digits';
export const VALUE_EXCEEDS_MAX_17 = 'validation.msg.value.must.be.less.than.17.digits';
export const UNSUPPORTED_FILE_FORMAT = 'validation.msg.unsupported.file.format';
export const EXCEEDS_TRADE_NAME_SIZE = 'validation.msg.trade.name.must.be.less.than.200.characters';
export const EXCEEDS_EDM_NUMBER_SIZE = 'validation.msg.edms.name.must.be.less.than.18.characters';
export const EXCEEDS_CHEMICAL_NAME_SIZE =
  'validation.msg.chemical.name.must.be.less.than.200.characters';
export const EXCEEDS_CMR_CATEGORY_SIZE =
  'validation.msg.cmr.category.must.be.less.than.200.characters';
export const EXCEEDS_SUPPLIER_NAME_SIZE =
  'validation.msg.supplier.name.must.be.less.than.200.characters';
export const EXCEEDS_PURITY_SIZE = 'validation.msg.purity.must.be.less.than.200.characters';
export const EXCEEDS_REMARKS_SIZE = 'validation.msg.remarks.must.be.less.than.4000.characters';
export const EXCEEDS_FORMULA_SIZE = 'validation.msg.formula.must.be.less.than.200.characters';
export const EXCEEDS_CHECK_CSE_COMMENTS_SIZE =
  'validation.msg.checkCseComments.must.be.less.than.4000.characters';
export const EXCEEDS_TECHNICAL_EQUIPMENT_SIZE =
  'validation.msg.technicalEquipment.must.be.less.than.200.characters';
export const EXCEEDS_EXPOSURE_MONITORING_DESC_SIZE =
  'validation.msg.exposureMonitoringDesc.must.be.less.than.1000.characters';
export const EXCEEDS_PROVIDED_DETAILS_SIZE =
  'validation.msg.providedDetails.must.be.less.than.2000.characters';
export const EXCEEDS_EMERGENCY_PROCEDURES_SIZE =
  'validation.msg.precautionsAndEmergencyProcedures.must.be.less.than.4000.characters';

export const EXCEEDS_FILE_SIZE_LIMIT = 'validation.msg.exceeds.file.size.limit';
export const VALUE_MUST_BE_VALID_EDMS_NUMBER = 'validation.msg.value.must.be.valid.edms.number';
export const CAS_FORMAT_IS_NOT_VALID = 'validation.msg.cas.format.must.be.valid';
export const DATE_VALUE_CANNOT_BE_IN_FUTURE = 'validation.msg.date.cannot.be.in.future';
export const PRECISE_LOCATION_HTTP_ERROR = 'validation.msg.precise.location.error';
export const OUT_OF_BUILDING_IS_REQUIRED = 'validation.msg.out.of.building.is.required';
export const OUT_OF_BUILDING_ERROR = 'validation.msg.out.of.building.error';

export const UN_NUMBER_OR_IS_REGULATED_IS_REQUIRED =
  'validation.msg.un.number.or.is.regulated.is.required';
export const HAZARD_STMT_OR_IS_NOT_HAZARDOUS_IS_REQUIRED =
  'validation.msg.hazard.stmt.or.is.not.hazardous.is.required';

export const EUH_STMT_OR_IS_NOT_APPLICABLE =
  'validation.msg.euh.stmt.or.is.not.applicable.is.required';

export const CANNOT_BE_DECLARED_NOT_HAZARDOUS = 'validation.cannot.be.declared.not.hazardous';

export const CANNOT_HAVE_EUH_STATEMENT = 'validation.cannot.be.declared.not.euh';

export const EXCLUDED_ERROR_MESSAGE = 'EXCLUDED_ERROR_MESSAGE';

export const SDS_FILE_SUPPORTED_FORMATS = ['application/pdf'];
export const INVENTORY_FILE_SUPPORTED_FORMATS = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/bmp',
  'image/gif',
];
export const FILE_SIZE_LIMIT = 40000000; //40mb

/**
 * this covers also empty strings for mixed();
 */
export function mixedCustomRequired() {
  return this.test({
    name: 'mixedCustomRequired',
    exclusive: false,
    message: VALUE_IS_REQUIRED,
    test: value => !!value,
  });
}

yup.addMethod(yup.mixed, 'mixedCustomRequired', mixedCustomRequired);

export function objectWithIdRequired() {
  return yup.object({
    id: yup.mixed().mixedCustomRequired(),
  });
}

export function stringRequired() {
  return yup.string().required(VALUE_IS_REQUIRED).nullable();
}

export function objectRequired() {
  return yup.object().required(VALUE_IS_REQUIRED).nullable();
}

export function isSameOrBeforeToday() {
  return this.test({
    name: 'isSameOrBeforeToday',
    exclusive: false,
    message: DATE_VALUE_CANNOT_BE_IN_FUTURE,
    test: value => !value || value.isSameOrBefore(moment(), 'day'),
  });
}

yup.addMethod(yup.object, 'isSameOrBeforeToday', isSameOrBeforeToday);

export function requiredIfRefEqualsTo(ref, refEqualsValue) {
  return this.test({
    name: 'requiredIfRefEqualsTo',
    exclusive: false,
    message: VALUE_IS_REQUIRED,
    test: function (value) {
      return !(refEqualsValue.map(v => v).includes(this.resolve(ref)) && !value);
    },
  });
}

yup.addMethod(yup.string, 'requiredIfRefEqualsTo', requiredIfRefEqualsTo);

export function requiredIfRefHasValue(ref) {
  return this.test({
    name: 'requiredIfRefHasValue',
    exclusive: false,
    message: VALUE_IS_REQUIRED,
    test: function (value) {
      return !(this.resolve(ref) && !value);
    },
  });
}

yup.addMethod(yup.object, 'requiredIfRefHasValue', requiredIfRefHasValue);
yup.addMethod(yup.string, 'requiredIfRefHasValue', requiredIfRefHasValue);

export function requiredIfRefHasNoValue(ref, msg) {
  return this.test({
    name: 'requiredIfRefHasNoValue',
    exclusive: false,
    message: msg,
    test: function (value) {
      return !(
        (!this.resolve(ref) || this.resolve(ref).length == 0) &&
        (!value || value.length == 0)
      );
    },
  });
}
yup.addMethod(yup.mixed, 'requiredIfRefHasNoValue', requiredIfRefHasNoValue);

export function tradeNameValidation(ref = null) {
  return this.test({
    name: 'tradeNameValidation',
    exclusive: false,
    message: TRADENAME_MUST_BE_UNIQUE,
    async test(value) {
      if (value) {
        const cpId = this.resolve(ref != null ? ref[0] : null);
        const supplier = this.resolve(ref != null ? ref[1] : null);
        const purity = this.resolve(ref != null ? ref[2] : null);

        let params = cpId ? `?id=${cpId}&` : '?';
        params += value ? `tradeName=${encodeURIComponent(value)}` : '';
        params += supplier?.name ? `&supplier=${encodeURIComponent(supplier.name)}` : '';
        params += purity ? `&purity=${encodeURIComponent(purity)}` : '';

        const requestOptions = {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${keycloak.token}`,
          },
        };

        const resp = await fetch(
          `${baseUrl}/validations/isTradenameUnique${params}`,
          requestOptions
        );
        return await resp.json().then(result => result);
      }
      return true;
    },
  });
}

yup.addMethod(yup.mixed, 'tradeNameValidation', tradeNameValidation);

export function gisRiskValidation(idRef, locationInfoRef, surfaceRef, hazardsRef) {
  return this.test({
    name: 'gisRiskValidation',
    exclusive: false,
    message: VALUE_IS_REQUIRED,
    async test() {
      const id = this.resolve(idRef);
      const locationInfo = this.resolve(locationInfoRef);
      const isRoom = locationInfo && locationInfo.includes('-');
      const surface = this.resolve(surfaceRef);
      const hazards = this.resolve(hazardsRef);

      if ((id && surface && hazards && hazards.length > 0) || (locationInfo && !isRoom)) {
        let params = `?id=${id}&isHazardous=true&isRoom=${isRoom}`;
        if (surface) {
          params += `&surface=${surface}`;
        }

        const requestOptions = {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${keycloak.token}`,
          },
        };

        const resp = await fetch(`${baseUrl}/validations/isGisRiskValid${params}`, requestOptions);
        if (resp.status === 200) {
          return resp.json();
        }
        return this.createError({ message: PRECISE_LOCATION_HTTP_ERROR });
      }
      return true;
    },
  });
}

yup.addMethod(yup.mixed, 'gisRiskValidation', gisRiskValidation);

export function outOfBuildingRequiredValidation(locationInfoRef) {
  return this.test({
    name: 'outOfBuildingRequiredValidation',
    exclusive: false,
    message: OUT_OF_BUILDING_IS_REQUIRED,
    test: function (value) {
      let locationInfo = this.resolve(locationInfoRef);
      let isRoom = !!locationInfo && locationInfo.includes('-');

      if (!value && !!locationInfo && !isRoom) return false;
      else return true;
    },
  });
}

yup.addMethod(yup.mixed, 'outOfBuildingRequiredValidation', outOfBuildingRequiredValidation);

export function outOfBuildingErrorValidation(locationInfoRef) {
  return this.test({
    name: 'outOfBuildingErrorValidation',
    exclusive: false,
    message: OUT_OF_BUILDING_ERROR,
    test: function (value) {
      let locationInfo = this.resolve(locationInfoRef);
      let isRoom = locationInfo && locationInfo.includes('-');

      if (value && isRoom) return false;
      else return true;
    },
  });
}

yup.addMethod(yup.mixed, 'outOfBuildingErrorValidation', outOfBuildingErrorValidation);

export function getRequiredFields(validationSchema) {
  let requiredFields = [];
  getRequiredFieldsRecursively(validationSchema.describe().fields, '', requiredFields);
  return requiredFields;
}

function getRequiredFieldsRecursively(fields, path, requiredFields) {
  if (fields) {
    Object.entries(fields).forEach(([key, val]) => {
      path = path ? path + '.' + key : key;
      if (val.tests && val.tests.find(t => ['mixedCustomRequired', 'required'].includes(t.name))) {
        requiredFields.push(path);
      }
      getRequiredFieldsRecursively(val.fields, path, requiredFields);
      path = path.substr(0, path.indexOf('.'));
    });
  }
}
